import React, { useContext, useState } from 'react';
import { Box, Button, Typography, TextField } from '@mui/material';
import _ from 'lodash';
import { Filepond, Input, Map } from '../components';
import { useCol, useFirebase } from '../hooks';
import '../style/field-details.scss';
import { FieldContext } from '../App';

export const AddField = () => {
    const { ownerId } = useContext(FieldContext);
    const [loading, setLoading] = useState(false);
    const [newImages, setNewImages] = useState({});
    const { data, updateRecord } = useCol('configurations');
    const { createRecord } = useCol('fields');
    const { storage } = useFirebase();
    const [update, setUpdate] = useState({ ownerId });

    const addImage = async (id) => {
        let urls = [];
        return await Object.values(newImages).map(async (cur, index) => {
            const storageRef = storage.ref();

            var uploadTask = await storageRef
                .child(`fields/${id}/${cur.name}`)
                .put(cur);

            const url = await uploadTask.ref.getDownloadURL();
            urls.push(url);

            if (_.size(urls) === _.size(newImages)) {
                createRecord(id, {
                    posters: urls,
                });
            }
        });
    };

    const addNewLocations = async () => {
        return await updateRecord('locations', {
            LOCATIONS: [...data[2].LOCATIONS, ...update.info.locations],
        });
    };

    const updateData = async () => {
        setLoading(true);

        try {
            const id = await createRecord('', update);
            await addImage(id);
            await addNewLocations();
            setLoading(false);
        } catch (err) {
            console.error(err);
        }
    };

    if (loading || !data) return <div>Loading...</div>;
    return (
        <Box
            overflow="scroll"
            fullWidth
            height="84vh"
            className="detail-container"
            p={3}
        >
            <Box p={2} display="flex" flexDirection="row" alignItems="center">
                <Typography>Нэр:</Typography>
                <Box m={1} />
                <TextField
                    fullWidth
                    variant="outlined"
                    defaultValue={''}
                    onChange={(e) =>
                        setUpdate({ ...update, name: e.target.value })
                    }
                />
            </Box>
            <Box p={2} display="flex" flexDirection="row" alignItems="center">
                <Typography>Түгээмэл Байршил:</Typography>
                <Input
                    value={''}
                    inputType="advantages"
                    placeholder="Locations"
                    freeSolo
                    noOptions
                    onTextChange={(change) =>
                        setUpdate({
                            ...update,
                            info: { ...update.info, locations: change },
                        })
                    }
                />
            </Box>
            <Box p={2} display="flex" flexDirection="row" alignItems="center">
                <Typography>Үндсэн хаяг:</Typography>
                <Box m={1} />
                <TextField
                    fullWidth
                    variant="outlined"
                    placeholder='Үндсэн хаяг'
                    defaultValue={''}
                    onChange={(e) =>
                        setUpdate({ ...update, mainLocation: e.target.value })
                    }
                />
            </Box>
            <Box p={2} display="flex" flexDirection="row" alignItems="center">
                <Typography>Бүтэн үнэ:</Typography>
                <Box m={1} />
                <TextField
                    type="number"
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ step: 1000 }}
                    fullWidth
                    variant="outlined"
                    defaultValue={''}
                    onChange={(e) =>
                        setUpdate({
                            ...update,
                            price: { ...update.price, fullPrice: e.target.value }
                        })
                    }
                />
            </Box>
            <Box p={2} display="flex" flexDirection="row" alignItems="center">
                <Typography>Хагас үнэ:</Typography>
                <Box m={1} />
                <TextField
                    type="number"
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ step: 1000 }}
                    fullWidth
                    variant="outlined"
                    defaultValue={''}
                    onChange={(e) =>
                        setUpdate({
                            ...update,
                            price: {...update.price, halfPrice: e.target.value}
                        })
                    }
                />
            </Box>
            <Box p={2} display="flex" flexDirection="row" alignItems="center">
                <Typography>Шалны материал:</Typography>
                <Box m={1} />
                <TextField
                    fullWidth
                    variant="outlined"
                    defaultValue={''}
                    onChange={(e) =>
                        setUpdate({
                            ...update,
                            info: {
                                ...update.info,
                                floorMaterial: e.target.value,
                            },
                        })
                    }
                />
            </Box>
            <Box
                padding={2}
                fullWidth
                display="flex"
                flexDirection="row"
                alignItems="center"
                justifyContent="space-between"
            >
                <Box display="flex" flexDirection="row" alignItems="center">
                    <Typography>Үнэлгээ:</Typography>
                    <Box m={1} />
                    <Input
                        label="Одоор"
                        inputType="size"
                        step="0.1"
                        value={''}
                        onTextChange={(text) =>
                            setUpdate({ ...update, rate: text })
                        }
                    />
                </Box>
                <Box m={'0 5'} />
                <Box display="flex" flexDirection="row" alignItems="center">
                    <Typography>Цаг:</Typography>
                    <Box m={1} />
                    <Input
                        inputType="time"
                        value={''}
                        label="Нээх цаг:"
                        placeholder="default"
                        onTextChange={(text) =>
                            setUpdate({
                                ...update,
                                timeTable: {
                                    ...update.timeTable,
                                    open: text,
                                },
                            })
                        }
                    />
                    <Box m={1} />
                    <Input
                        inputType="time"
                        value={''}
                        label="Хаах цаг:"
                        placeholder="default"
                        onTextChange={(text) =>
                            setUpdate({
                                ...update,
                                timeTable: {
                                    ...update.timeTable,
                                    close: text,
                                },
                            })
                        }
                    />
                </Box>

                <Box m={'0 5'} />
                <Box display="flex" flexDirection="row" alignItems="center">
                    <Typography>Заалны:</Typography>
                    <Box m={1} />
                    <Input
                        label="Урт:"
                        inputType="size"
                        step="1"
                        variant="outlined"
                        value={''}
                        onTextChange={(text) =>
                            setUpdate({
                                ...update,
                                info: {
                                    ...update.info,
                                    size: {
                                        ...update.size,
                                        length: text
                                    },
                                },
                            })
                        }
                    />
                    <Box m={1} />
                    <Input
                        label="Өргөн:"
                        inputType="size"
                        step="1"
                        variant="outlined"
                        value={''}
                        onTextChange={(text) =>
                            setUpdate({
                                ...update,
                                info: {
                                    ...update.info,
                                    size: {
                                        ...update.size,
                                        width: text
                                    },
                                },
                            })
                        }
                    />
                </Box>
            </Box>

            <Box p={2} display="flex" flexDirection="row" alignItems="center">
                <Typography>Давуу талууд:</Typography>
                <Box m={1} />
                <Input
                    value={[]}
                    inputType="advantages"
                    placeholder="Advantages"
                    onTextChange={(change) =>
                        setUpdate({
                            ...update,
                            info: { ...update.info, advantages: change },
                        })
                    }
                />
            </Box>
            <Box p={2} display="flex" flexDirection="row" alignItems="center">
                <Typography>Утасны дугаарууд:</Typography>
                <Box m={1} />
                <Input
                    value={''}
                    inputType="advantages"
                    placeholder={'Phone numbers'}
                    freeSolo
                    noOptions
                    onTextChange={(change) =>
                        setUpdate({
                            ...update,
                            info: { ...update.info, phoneNumbers: change },
                        })
                    }
                />
            </Box>
            <Map
                coordinate={{
                    latitude: 47.91599579116742,
                    longitude: 106.91915817270011,
                }}
                setCoordinate={(coordinate) =>
                    setUpdate({
                        ...update,
                        coordinate: coordinate,
                    })
                }
            />

            <Box m={4} />
            <Box className="image-box">
                <Filepond images={newImages} setImages={setNewImages} />
            </Box>

            <Box m={4} />

            <Button
                fullWidth
                onClick={updateData}
                variant="contained"
                color="primary"
            >
                save
            </Button>
        </Box>
    );
};
